import { render, staticRenderFns } from "./SetSubstanteinDlg.vue?vue&type=template&id=5c5c5080&"
import script from "./SetSubstanteinDlg.vue?vue&type=script&lang=js&"
export * from "./SetSubstanteinDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports